module.exports = __webpack_public_path__ + "Roboto-Light.fc84e998bc29b297ea20.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Light.ttf
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Light.ttf
// module chunks = styles